/**
 * Sleep for a given number of milliseconds (in an async function)
 * @param ms - number of milliseconds to sleep
 * @returns a promise that resolves after the given number of milliseconds
 */
export async function sleepAsync(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
